import React from 'react';
import {
	getPasswordCriteria,
	passwordStrengthRatio,
} from '../utils/passwordPolicy';

import '../assets/scss/PasswordStrengthHints.scss';

/**
 * @param {{ password: string, username?: string, email?: string }} props
 */
const PasswordStrengthHints = ({ password, username, email }) => {
	const c = getPasswordCriteria(password, { username, email });
	const ratio = passwordStrengthRatio(password, { username, email });
	const showIdentity = Boolean(username || email);

	const rows = [
		{ key: 'len', ok: c.lengthOk, label: '8–64 tegn' },
		{ key: 'lo', ok: c.lower, label: 'Minst én liten bokstav' },
		{ key: 'up', ok: c.upper, label: 'Minst én stor bokstav' },
		{ key: 'sp', ok: c.special, label: 'Minst ett spesialtegn (ikke bare bokstaver/siffer)' },
	];

	if (showIdentity) {
		rows.push({
			key: 'id',
			ok: c.notIdentity,
			label: 'Ikke lik brukernavn eller e-post',
		});
	}

	return (
		<div className='password-strength-hints' aria-live='polite'>
			<div
				className='password-strength-hints__bar'
				role='progressbar'
				aria-valuemin={0}
				aria-valuemax={100}
				aria-valuenow={Math.round(ratio * 100)}
			>
				<div
					className='password-strength-hints__bar-fill'
					style={{ width: `${Math.round(ratio * 100)}%` }}
				/>
			</div>
			<ul className='password-strength-hints__list'>
				{rows.map(({ key, ok, label }) => (
					<li
						key={key}
						className={
							ok
								? 'password-strength-hints__item password-strength-hints__item--ok'
								: 'password-strength-hints__item password-strength-hints__item--missing'
						}
					>
						{ok ? '✓' : '·'} {label}
					</li>
				))}
			</ul>
		</div>
	);
};

export default PasswordStrengthHints;
